import initSignUp from 'sign_up'

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[data-sign-up-url]')
  if (form) initSignUp(form)
})
